module.exports = __webpack_public_path__ + "img/xytl-top-banner.e6010b82.gif";